"use client"

import { ErrorPage } from "@eurodrive/pages"

export default function Error() {
  return <ErrorPage />
}
